module.exports = __webpack_public_path__ + "static/media/Mask Group.5c8d5f73.png";